import * as React from "react";

import Loading from "@common/components/Atoms/Loading";
import { TileSize } from "@common/models/enums";

interface DashboardTileProps {
    size: TileSize,
    title: string,
    description: string,
    loading?: boolean,
    showFade?: boolean,
    className?: string,
    children?: React.ReactNode,
    nav?: React.ReactNode,
    footer?: React.ReactNode,
    style?: any
};

export const DashboardTile: React.SFC<DashboardTileProps> = (props: DashboardTileProps) => {
    const classes = ["c-dashboard__tile"];

    classes.push("c-dashboard__tile--" + TileSize[props.size]);
    if (props.className) {
        classes.push(props.className);
    }

    return (
        <div className={classes.join(" ")} style={props.style}>
            <div className="c-dashboard__tile-container">
                <div className="c-dashboard__tile-header">
                    <div className="c-dashboard__tile-description">
                        <h2>{props.title}</h2>
                        <p>{props.description}</p>
                    </div>
                    {props.nav}
                </div>
                <div className="c-dashboard__tile-body">
                    <div className="c-dashboard__tile-content">
                        {props.loading ? (
                            <Loading empty={true} modifierClass="c-loading__center" />
                        ) : (
                                props.children
                            )}
                    </div>
                    {props.showFade &&
                        <React.Fragment>
                            <div className="c-dashboard__tile-fade-top" />
                            <div className="c-dashboard__tile-fade-bottom" />
                        </React.Fragment>
                    }
                </div>
                {props.footer}
            </div>
        </div>
    );
};
